import { lighten } from '@mui/material/styles';
import { makeStyles } from '../../../styles';
export const useButtonStyles = makeStyles((theme) => ({
    root: Object.assign(Object.assign({}, theme.typography.subtitle1), { textAlign: 'center', borderRadius: 8, textTransform: 'none', '&.MuiButton-sizeSmall': {
            padding: theme.spacing(0.5, 1.5),
        }, '&.MuiButton-sizeMedium': {
            padding: theme.spacing(0.75, 2),
        }, '&.MuiButton-sizeLarge': {
            padding: theme.spacing(1, 2.5),
        }, '&.MuiButton-containedPrimary': {
            '&.Mui-disabled:not(.MuiLoadingButton-loading)': {
                backgroundColor: lighten(theme.colors.primary.main, 0.75),
            },
        }, '&.MuiButton-outlinedPrimary': {
            '&.Mui-disabled:not(.MuiLoadingButton-loading)': {
                borderColor: lighten(theme.colors.primary.main, 0.75),
                color: lighten(theme.colors.primary.main, 0.75),
            },
        } }),
    contained: {
        boxShadow: 'none',
        '&:hover,&:active': {
            boxShadow: 'none',
        },
        '&:disabled:not(.MuiLoadingButton-loading)': {
            color: theme.colors.primary.contrastWhite,
        },
    },
    dashed: {
        borderStyle: 'dashed',
        '&.Mui-disabled': {
            borderStyle: 'dashed',
            '&.MuiButton-outlinedPrimary:not(.MuiLoadingButton-loading)': {
                borderColor: lighten(theme.colors.primary.main, 0.75),
                color: lighten(theme.colors.primary.main, 0.75),
            },
        },
    },
}));
//# sourceMappingURL=Button.styles.js.map